import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useEffect } from "react";
import {
	$getRoot,
	$getSelection,
	$insertNodes,
	$isRangeSelection,
	COMMAND_PRIORITY_EDITOR,
	LexicalEditor,
} from "lexical";
import { createCommand } from "lexical";
import { $generateNodesFromDOM } from "@lexical/html";
import { InsertTemplateCommandModel, InsertType } from "@/common/types/lexicalEditor";

const INSERT_TEMPLATE_COMMAND = createCommand<InsertTemplateCommandModel>();

export const InsertTemplatePlugin = () => {
	const [editor] = useLexicalComposerContext();

	useEffect(() => {
		return editor.registerCommand(
			INSERT_TEMPLATE_COMMAND,
			(params: InsertTemplateCommandModel) => {
				const selection = $getSelection();

				if ($isRangeSelection(selection)) {
					const parser = new DOMParser();
					const dom = parser.parseFromString(params.template, "text/html");

					const nodes = $generateNodesFromDOM(editor, dom);

					if (params.insertType == InsertType.AtCursor) {
						selection.insertNodes(nodes);
					} else {
						const root = $getRoot();
						root.clear();

						$getRoot().select();
						$insertNodes(nodes);
					}
				}

				$getRoot().selectStart();

				return true;
			},
			COMMAND_PRIORITY_EDITOR
		);
	}, [editor]);

	return null;
};

export const insertTemplate = (
	editor: LexicalEditor | undefined,
	template: string,
	insertType: InsertType
) => {
	editor?.dispatchCommand(INSERT_TEMPLATE_COMMAND, { template, insertType });
};
